module.exports = __webpack_public_path__ + "static/media/4.250f1d30.jpg";